import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Kartable_Controller_Review_Interface } from 'src/app/Interface/Kartable_Controller_Review_Interface';
import { Kartable_Customer_Device_Interface } from 'src/app/Interface/Kartable_Customer_Device_Interface';
import { Kartable_Device_Point_Interface } from 'src/app/Interface/Kartable_Device_Point_Interface';

export interface DevicePoint2YearItem {
  fullName: string;
  year: number;
  month: number;
  monthName: string;
  totalT4: number;
  working?: number;
}

export interface DevicePoint2WorkingItem {
  year: number;
  month: number;
  monthName: string;
  working: number;
}

export interface DevicePoint2YearsResponse {
  current_Year_chart2?: DevicePoint2YearItem[];
  last_Year_chart2?: DevicePoint2YearItem[];
  current_Year_Working?: DevicePoint2WorkingItem[];
  last_Year_Working?: DevicePoint2WorkingItem[];
}
import { Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { Kartable_Station_Interface } from 'src/app/Interface/Kartable_Station_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KartableService {

  constructor(private http: HttpClient) { }


  GetOrder(): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetOrder").pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetOrderCount(): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetOrderCount").pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetStation(): Observable<Array<Kartable_Station_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetStation").pipe(
      map(data => {
        return data as Array<Kartable_Station_Interface>
      })
    )
  }

  GetCalibrationInLocation(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetCalibrationInLocation?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetController(PeriodDate: number,
    StartSearchDate: String,
    EndSearchDate: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetController?PeriodDate=" + PeriodDate
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetCertificate(Customer: String,
    Expert_Name: String,
    RecieveCode: String,
    LetterCode: String,
    Devicename: String,
    PeriodDate: number,
    StartSearchDate: String,
    EndSearchDate: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetCertificate?Expert_Name=" + Expert_Name
      + "&RecieveCode=" + RecieveCode
      + "&LetterCode=" + LetterCode
      + "&CustomerName=" + Customer
      + "&PeriodDate=" + PeriodDate
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&Devicename=" + Devicename).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SubmitController(id: number,
    status: number,
    customer: String,
    dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Kartable/SubmitController?id=" + id
      + "&status=" + status
      + "&dsc=" + dsc
      + "&customer=" + customer
      ).pipe(
        map(data => {
          return data as any
        })
      )

  }

  SetCalibrationDetailVisible(id: number): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Kartable/SetCalibrationDetailVisible?id=" + id ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetContollerReview(StartSearchDate: String,
    EndSearchDate: String,
    username: String): Observable<Array<Kartable_Controller_Review_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetContollerReview?username=" + username
      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Controller_Review_Interface>
        })
      )
  }

  GetDevicePoint(StartSearchDate: String,
    EndSearchDate: String,
    username: String): Observable<Array<Kartable_Device_Point_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetDevicePoint?username=" + username
      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Device_Point_Interface>
        })
      )
  }

  GetDevicePoint2(StartSearchDate: String,
    EndSearchDate: String,
    deviceName: String,
    customerName: String,
    period: number,
    accept: number,
    LocationOfCalibration: number,
    expert: String): Observable<Array<Kartable_Device_Point_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetDevicePoint2?period=" + period
      + "&accept=" + accept
      + "&customerName=" + customerName
      + "&deviceName=" + deviceName
      + "&CalibrationExpert=" + expert
      + "&LocationOfCalibration=" + LocationOfCalibration
      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Device_Point_Interface>
        })
      )
  }
 
  GetDevicePoint2Years(deviceName: String,
    customerName: String,
    LocationOfCalibration: number,
    expert: String): Observable<DevicePoint2YearsResponse> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetDevicePoint2Years?customerName=" + customerName
      + "&deviceName=" + deviceName
      + "&CalibrationExpert=" + expert
      + "&LocationOfCalibration=" + LocationOfCalibration).pipe(
        map(data => {
          return data as DevicePoint2YearsResponse
        })
      )
  }



  SubmitCertificate(id: number, dsc: string): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Kartable/SubmitCertificate?id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }


  GetCustomerDeviceReview(StartSearchDate: String,
    EndSearchDate: String,
    Customer: String): Observable<Array<Kartable_Customer_Device_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Kartable/GetCustomerDeviceReview?customerName=" + Customer

      + "&startdate=" + StartSearchDate
      + "&enddate=" + EndSearchDate).pipe(
        map(data => {
          return data as Array<Kartable_Customer_Device_Interface>
        })
      )
  }



  GetBarchasb(letter_id:Number,customename:string): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Kartable/GetBarchasb?letter_id=" + letter_id+"&customename=" + customename).pipe(
      map(data => {
        return data as Array<any>
      })
    )
  }


  ConfirmBarchasb(
    id: Array<number>
  ): Observable<any> {

    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
    }

    return this.http.post(environment.BaseUrl + "Daro/Kartable/ConfirmBarchasb", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

}
